
import { Button } from 'element-ui';
import LoyaltyOurStatus from '@/pages/account/components/LoyaltyOurStatus.vue';
import EarnPoints from '@/pages/account/components/EarnPoints.vue';
import LoyaltyAwardsCatalog from '@/pages/account/components/LoyaltyAwardsCatalog.vue';
import LoyaltyJoinUs from '@/pages/account/components/LoyaltyJoinUs.vue';

export default {
  layout: 'MainLayout',
  auth: false,
  nuxtI18n: {
    paths: {
      en: '/loyalty-program/index',
      fr: '/programme-fidelite/index',
      de: '/programm-fidelite/index',
    },
  },
  data() {
    return {
      shopPage: null,
    };
  },

  computed: {
    breadcrumbLinks() {
      return [
        {
          link: '/',
          text: this.$t('Home'),
        },
        {
          text: this.$t('Our shops'),
        },
      ];
    },
    loyaltyLink() {
      let link = this.localePath({ name: `account-loyalty-membership` });
      if (!this.$auth.loggedIn) {
        return this.localePath({
          name: 'authenticate-route',
          params: {
            route: 'login',
          },
          query: {
            redirect: 'account-loyalty-membership',
          },
        });
      }
      return link;
    },
  },

  methods: {
    scrollToSection(sectionId) {
      if (process.client) {
        const element = document.getElementById(sectionId);
        if (element) {
          const y = element.getBoundingClientRect().top + window.scrollY - 200; // Added 80px offset for better visibility
          window.scrollTo({
            top: y,
            behavior: 'smooth',
          });
        }
      }
    },
  },

  mounted() {
    if (process.client) {
      window.scrollTo(0, 0);
    }
  },
  components: {
    Button,
    EarnPoints,
    LoyaltyJoinUs,
    LoyaltyOurStatus,
    LoyaltyAwardsCatalog,
  },
};
